<template>
	<div>
		<div class="title-container">
			<div class="title"><span class="fad fa-flag"></span>{{ flags.length }} Module Flag{{ flags.length !== 1 ? 's' : '' }}</div>
			<div class="buttons-container buttons">
				<router-link :to="`/admin/accounts/${ account.id }/modules`" class="button"><div class="hover-title">Go Back</div><span class="fa fa-chevron-left"></span></router-link>
				<router-link :to="{ name: 'super-account-flags-create-page', params: $route.params }" class="button"><div class="hover-title">Add Flag</div><span class="fa fa-plus"></span></router-link>
			</div>
		</div>

		<div class="table list">
			<div v-if="flags.length > 0" class="row">
				<div class="cell"><a href @click.prevent class="point-up">Module<span class="fa fa-angle-down"></span></a></div>
				<div class="cell"><a href @click.prevent class="point-down">Name</a></div>
				<div class="cell"></div>
			</div>
			<div v-for="flag in flags" :key="`account-${ account.id }-${ flag.id }`"  class="row">
				<div class="cell">{{ flag.module ? flag.module.name : 'No longer exists' }}</div>
				<div class="cell">{{ flag.name }}</div>
				<div class="cell align-right">
					<div class="buttons">
						<delete-button @deleted="(done) => deleteRow(flag, done)">
							<router-link :to="`/admin/accounts/${ account.id }/flags/${ flag.id }/edit`" class="button"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></router-link>
						</delete-button>
					</div>
				</div>
			</div>

			<nothing-here v-if="flags.length === 0"></nothing-here>
		</div>
	</div>
</template>

<script>

import DeleteButton from '@/views/components/DeleteButton';

export default {

	name: 'ModuleFlagsOverviewPage',

	async asyncData({ app, route, store }) {
		const { data } = await app.$api.get(`/super/accounts/${ route.params.accountId }/flags`);

		return {
			flags: data.data,
			account: store.state.auth.accountsById[ route.params.accountId ],
		};
	},

	data() {
		return {
			flags: [],
		};
	},

	methods: {

		async deleteRow(flag, done) {
			await this.$api.post(`/super/accounts/${ this.account.id }/flags/${ flag.id }/delete`).then(() => {
				this.$store.dispatch('addToast', `${ flag.module.name } ${ flag.action } Deleted`);
				this.flags = this.flags.filter(({ id }) => id !== flag.id);
				done();
			});
		}

	},

	components: {
		DeleteButton,
	},

};

</script>
